import setClauseErrorText from '../actions/helpers/setClauseErrorText';
import setFocusedClauseId from '../actions/helpers/setFocusedClauseId';
import setClauseValue from '../actions/setClauseValue';
import store from '../store/store';
import { observer } from 'mobx-react';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { IButton } from 'office-ui-fabric-react/lib/components/Button';
import { DirectionalHint } from 'office-ui-fabric-react/lib/Tooltip';
import { getCategoryColorsForCategory, getCategoryMenuProps } from 'owa-categories';
import { getMasterCategoryList } from 'owa-categories';
import { ControlIcons } from 'owa-control-icons';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';

export interface CategoryClauseValueProps {
    clauseId: string;
}
const styles = require('./InboxRuleClause.scss');
let classNames = require('classnames/bind').bind(styles);

@observer
export default class CategoryClauseValue extends React.Component<CategoryClauseValueProps, {}> {
    private categoryButtonRef: IButton;
    private categoryName: string;

    render() {
        let iconStyles;
        let clauseId = this.props.clauseId;
        let errorText = store.inboxRulesEditState.clauseErrorTextMap.get(clauseId);
        const clause = store.inboxRulesEditState.clauseMap.get(clauseId);

        // if the user selected a clause from the dropdown or has an existing clause,
        // set the categoryName class variable, which is used to update the UI
        if (clause.clauseValue) {
            this.categoryName = clause.clauseValue[0];
        }

        if (this.categoryName) {
            let categoryColor = getCategoryColorsForCategory(
                this.categoryName,
                getMasterCategoryList()
            ).iconColor;
            iconStyles = { color: categoryColor };
        }

        const categoryMenuProps = getCategoryMenuProps({
            actionSource: 'Rules',
            categoryList: getMasterCategoryList(),
            categoriesToCheck: [],
            dismissMenu: () => {
                // we must explicitly call dismissMenu from the button ref because it does not close when focus is lost
                this.categoryButtonRef.dismissMenu();
                setFocusedClauseId(clauseId, false /* shouldSetAsFocused */);
            },
            shouldShowSearchBox: true /* shouldShowSearchBox */,
            shouldShowManageCategories: false,
            shouldShowClearCategories: false,
            onAfterCreateNewCategory: (category: string, addCategoryPromise: Promise<boolean>) => {
                // update categoryName so UI will immediately update
                this.categoryName = category;
                addCategoryPromise.then((wasSuccessful: boolean) => {
                    setClauseErrorText(clauseId, wasSuccessful /* isValidClause */, category);
                    if (!wasSuccessful) {
                        // on failure, revert UI
                        this.categoryName = null;
                        setClauseValue([], clauseId);
                    } else {
                        setClauseValue([category], clauseId);
                    }
                });
            },
            onCheckedCategoryClicked: category =>
                setClauseValue([category], clauseId) /* onCheckedCategoryClicked */,
            onUncheckedCategoryClicked: category =>
                setClauseValue([category], clauseId) /* onUncheckedCategoryClicked */,
            directionalHint: DirectionalHint.topCenter,
            useTargetWidth: true /* useTargetWidth */,
            coverTarget: true /* coverTarget */,
        });

        let buttonStyles = {
            root: styles.categoryMoveToPickerButton,
            label: this.categoryName
                ? styles.categoryMoveToPickerText
                : styles.categoryMoveToPickerPlaceholderText,
        };

        return (
            <div className={styles.categoryContainer}>
                <DefaultButton
                    componentRef={ref => {
                        this.categoryButtonRef = ref;
                    }}
                    text={
                        this.categoryName
                            ? this.categoryName
                            : strings.options_inboxRules_categorizeDropdownPlaceholder
                    }
                    menuProps={categoryMenuProps}
                    className={classNames(
                        styles.categoryMoveToPickerButton,
                        errorText && styles.hasError
                    )}
                    styles={buttonStyles}
                    iconProps={
                        this.categoryName && {
                            iconName: ControlIcons.Tag,
                            styles: {
                                root: iconStyles,
                            },
                        }
                    }
                />
                {errorText && <span className={styles.errorText}>{errorText}</span>}
            </div>
        );
    }
}
